/* eslint-disable camelcase */

import BaseProvider from './base-provider';
import { getPaymentData } from './helpers/phoenix';

export default class PhoenixDataProvider extends BaseProvider {
  async makePayment(paymentType) {
    await this.nativeBridge.makePaymentFromNative(getPaymentData(paymentType));
  }
}
